"use client";

import { useEffect } from "react";

export default function ConversionPixel() {
  useEffect(() => {
    const pixel = document.createElement("img");
    pixel.src =
      "https://arttrk.com/pixel/?ad_log=referer&action=lead&pixid=c862610a-097d-4bdc-88d2-9e5968a6e2d9";
    pixel.width = 1;
    pixel.height = 1;
    pixel.style.position = "absolute";
    pixel.style.border = "0";
    document.body.appendChild(pixel);

    return () => {
      document.body.removeChild(pixel);
    };
  }, []);

  return null;
}
